
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      {/* Image Background */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://scontent-mrs2-3.xx.fbcdn.net/v/t39.30808-6/488543594_1227517356044741_6434282415808992123_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=127cfc&_nc_ohc=a6fXbK69LZgQ7kNvwGUmSom&_nc_oc=AdmcORov5qmjSFWGA8I8S2D1Rguq-s8ajSh0pC_leK3iYFnfCUSV1c4M0x7eSzaqYzI&_nc_zt=23&_nc_ht=scontent-mrs2-3.xx&_nc_gid=OKeWlp_xuPr49DQSc-0Dgg&oh=00_Afh7hITdNiHAujHCpr2b7KO9JA04MDoYX6bhGfgHU30t0w&oe=692DC162"
          alt="Le Bokal Givré - Brunch Tropical Saint-Pierre La Réunion"
          title="Le Bokal Givré - Brunch buffet à volonté"
          className="w-full h-full object-cover object-top scale-110 animate-[scale_20s_ease-in-out_infinite]"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#4A7C59]/70 via-black/50 to-[#FF8F6B]/60"></div>
      </div>

      {/* Floating Emojis */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <span className="absolute top-20 left-4 md:left-10 text-4xl md:text-6xl animate-float" style={{ animationDelay: '0s' }}>🌴</span>
        <span className="absolute top-40 right-10 md:right-20 text-3xl md:text-5xl animate-float" style={{ animationDelay: '1s' }}>🍍</span>
        <span className="absolute bottom-40 left-10 md:left-20 text-3xl md:text-5xl animate-float" style={{ animationDelay: '2s' }}>🥭</span>
        <span className="absolute top-60 right-20 md:right-40 text-3xl md:text-4xl animate-float" style={{ animationDelay: '1.5s' }}>🥥</span>
        <span className="absolute bottom-60 right-4 md:right-10 text-4xl md:text-6xl animate-float" style={{ animationDelay: '0.5s' }}>☀️</span>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        {/* Badge */}
        <div className="glass px-4 md:px-6 py-2 md:py-3 rounded-full mb-4 md:mb-6 animate-slide-up border-2 border-white/30">
          <p className="text-white font-bold text-xs md:text-sm tracking-widest flex items-center gap-2">
            <span className="w-2 h-2 bg-[#FF8F6B] rounded-full animate-pulse"></span>
            SAINT-PIERRE, LA RÉUNION 974
          </p>
        </div>

        {/* Main Title with Gradient */}
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-9xl font-black text-white mb-3 md:mb-4 animate-slide-up leading-tight" style={{ fontFamily: 'Pacifico, cursive', animationDelay: '0.1s' }}>
          <span className="inline-block hover:scale-110 transition-transform cursor-default">Le</span>{' '}
          <span className="inline-block hover:scale-110 transition-transform cursor-default text-gradient-animated">Bokal</span>{' '}
          <span className="inline-block hover:scale-110 transition-transform cursor-default">Givré</span>
        </h1>

        {/* Subtitle */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 mb-6 md:mb-8 animate-slide-up" style={{ animationDelay: '0.2s' }}>
          <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#FF8F6B] neon-glow">Brunch</span>
          <span className="text-white text-2xl md:text-3xl">•</span>
          <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white">Tapas</span>
          <span className="text-white text-2xl md:text-3xl">•</span>
          <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#F5E6D3]">Bar</span>
        </div>

        <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 md:mb-12 font-light tracking-wide animate-slide-up px-4" style={{ animationDelay: '0.3s' }}>
          L'expérience brunch qui va vous faire kiffer 🔥
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 md:gap-6 animate-slide-up w-full px-4 sm:w-auto" style={{ animationDelay: '0.4s' }}>
          <button 
            onClick={() => scrollToSection('reservation')}
            className="group relative px-6 md:px-10 py-4 md:py-5 bg-gradient-to-r from-[#FF8F6B] to-[#ff6b47] text-white rounded-full text-lg md:text-xl font-bold overflow-hidden transition-all transform hover:scale-110 shadow-2xl cursor-pointer whitespace-nowrap hover:shadow-[#FF8F6B]/50"
          >
            <span className="relative z-10 flex items-center justify-center gap-2">
              Réserver maintenant
              <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform"></i>
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-[#ff6b47] to-[#FF8F6B] opacity-0 group-hover:opacity-100 transition-opacity"></div>
          </button>
          
          <button 
            onClick={() => scrollToSection('brunch')}
            className="group px-6 md:px-10 py-4 md:py-5 glass border-2 border-white text-white rounded-full text-lg md:text-xl font-bold hover:bg-white hover:text-[#4A7C59] transition-all transform hover:scale-110 cursor-pointer whitespace-nowrap shadow-2xl"
          >
            <span className="flex items-center justify-center gap-2">
              Découvrir le concept
              <i className="ri-restaurant-line group-hover:rotate-12 transition-transform"></i>
            </span>
          </button>
        </div>

        {/* Social Proof */}
        <a 
          href="https://www.instagram.com/lebokalgivre/"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 md:mt-12 glass px-4 md:px-8 py-3 md:py-4 rounded-full animate-slide-up inline-block hover:scale-105 transition-transform cursor-pointer" 
          style={{ animationDelay: '0.5s' }}
        >
          <p className="text-white font-semibold flex items-center gap-2 md:gap-3 text-sm md:text-base">
            <i className="ri-instagram-line text-xl md:text-2xl text-[#FF8F6B]"></i>
            <span>+10K abonnés nous font confiance</span>
            <span className="text-xl md:text-2xl">✨</span>
          </p>
        </a>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 md:bottom-12 left-1/2 -translate-x-1/2 hidden md:flex">
          <div className="flex flex-col items-center gap-2 animate-bounce">
            <p className="text-white text-sm font-semibold tracking-widest">SCROLL</p>
            <i className="ri-arrow-down-line text-white text-4xl"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
